import React from 'react'
import PropTypes from 'prop-types'
import DatoImage from 'js/components/DatoRichText/DatoImage'
export default function ListWithIcons({ listItems }) {
  return (
    <ul className="mb-72 mt-36 grid max-w-968 gap-12 gap-x-10 md:grid-cols-2">
      {listItems.map((item) => {
        return (
          <li className="flex items-center" key={item.id}>
            <div className="w-80 shrink-0">
              <DatoImage {...item.image.responsiveImage} sizes="25vw" />
            </div>
            <div className="ml-24">
              <h3 className="type-20 lg:type-24">{item.heading}</h3>
              <p>{item.body}</p>
            </div>
          </li>
        )
      })}
    </ul>
  )
}

ListWithIcons.propTypes = {
  listItems: PropTypes.array,
}
